import gql from 'graphql-tag';
import client from '../../client';
export const CHANGE_PAYMENT_BILLING_ADDRESS = gql `
  mutation paymentMethod($paymentMethodId: String!, $input: PaymentBillingAddressInput!) {
    paymentBillingAddress(userId: $userId, paymentMethodId: $paymentMethodId, input: $input)
    @rest(type: "PaymentBillingAddress", path: "payments/{args.userId}/{args.paymentMethodId}/billing_details", method: "PATCH") {
      data {
        address {
          city
          country
          line1
          line2
          postal_code
          state
        }
        name
        email
        phone
      }
    }
  }
`;
export const changePaymentBillingAddress = (userId, paymentMethodId, input) => {
    return client.mutate({
        mutation: CHANGE_PAYMENT_BILLING_ADDRESS,
        variables: {
            userId,
            paymentMethodId,
            input,
        },
    });
};
export default changePaymentBillingAddress;
